var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3507 5.95577L21.9461 11.1098C22.2005 11.6158 22.6915 11.9666 23.2608 12.0478H29.0669C30.5014 12.2537 31.0382 13.5098 30 14.5L25.3327 18.0909C24.9201 18.4853 25.2351 20.7741 25.3327 21.3308L26.3236 26.9922C26.5676 28.3927 25.068 29.4612 23.7858 28.7986L18.5965 26.1238C18.0878 25.8614 16.1622 24.9194 15.652 25.1818L10.232 28.7986C8.94986 29.4612 8.99719 28.3927 9.24268 26.9922L10.232 21.3308C10.3296 20.7741 10.1418 20.2072 9.72922 19.8129L5.53072 15.8027C4.49256 14.8125 5.0634 13.0844 6.4979 12.8785L12.3039 12.0478C12.8733 11.9666 13.3658 11.6158 13.6201 11.1098L16.2141 5.95577C16.8559 4.68141 18.7089 4.68141 19.3507 5.95577Z",
    fill: "#FC5C42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8404 1.96135L20.8861 8.04594C21.1846 8.64327 21.7608 9.05747 22.4289 9.15331L29.2422 10.134C30.9256 10.3771 31.5955 12.4173 30.3772 13.5862L25.4503 18.3204C24.9661 18.786 24.7457 19.4552 24.8603 20.1124L26.023 26.796C26.3093 28.4494 24.5496 29.7108 23.045 28.9286L16.9554 25.7708C16.3584 25.461 15.6434 25.461 15.0446 25.7708L8.95501 28.9286C7.45039 29.7108 5.69066 28.4494 5.97874 26.796L7.13974 20.1124C7.25428 19.4552 7.03388 18.786 6.5497 18.3204L1.6228 13.5862C0.404525 12.4173 1.0744 10.3771 2.75777 10.134L9.57109 9.15331C10.2392 9.05747 10.8171 8.64327 11.1156 8.04594L14.1596 1.96135C14.9128 0.456893 17.0872 0.456893 17.8404 1.96135Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c126925c.svg";
export { ForwardRef as ReactComponent };